import type { ReactNode } from 'react';

export type NavIconKind =
  | 'parcel'
  | 'consolidate'
  | 'bag'
  | 'warehouse'
  | 'scan'
  | 'shipment'
  | 'manifest'
  | 'scales'
  | 'settings'
  | 'labels'
  | 'qesMail'
  | 'wbLabel'
  | 'azLabel'
  | 'geLabel'
  | 'parcelLabel';

const drawings: Record<NavIconKind, ReactNode> = {
  parcel: (
    <>
      <path d="m3.5 7 8.5-4 8.5 4v10L12 21l-8.5-4z" />
      <path d="M3.5 7 12 11l8.5-4M12 11v10M8 5l8.5 4" />
    </>
  ),
  consolidate: (
    <>
      <rect x="3" y="4" width="6" height="6" rx="1" />
      <rect x="15" y="4" width="6" height="6" rx="1" />
      <path d="M6 10v4l6 3 6-3v-4M12 17v4M9 21h6" />
    </>
  ),
  bag: (
    <>
      <path d="M8 3h8l-1.5 5c3.3 2.7 5.5 5.4 5.5 8.5A4.5 4.5 0 0 1 15.5 21h-7A4.5 4.5 0 0 1 4 16.5C4 13.4 6.2 10.7 9.5 8z" />
      <path d="M8.5 8h7M9 12h6" />
    </>
  ),
  warehouse: (
    <>
      <path d="m2.5 9 9.5-6 9.5 6v11h-19z" />
      <path d="M7 20v-8h10v8M7 15h10M11 12v8" />
    </>
  ),
  scan: (
    <>
      <path d="M4 8V5a1 1 0 0 1 1-1h3M16 4h3a1 1 0 0 1 1 1v3M20 16v3a1 1 0 0 1-1 1h-3M8 20H5a1 1 0 0 1-1-1v-3M4 12h16" />
      <path d="M8 9v2M11 9v2M14 9v2M17 9v2" />
    </>
  ),
  shipment: (
    <>
      <path d="M3 6h11v11H3zM14 10h4l3 3v4h-7" />
      <circle cx="7" cy="18" r="2" />
      <circle cx="18" cy="18" r="2" />
    </>
  ),
  manifest: (
    <>
      <rect x="5" y="4" width="14" height="17" rx="2" />
      <path d="M9 4.5V3h6v1.5M9 10h6M9 14h2M13 16l2 2 3-4" />
    </>
  ),
  scales: (
    <>
      <path d="M12 3v17M5 6h14M7 6l-3 8h6zM17 6l-3 8h6zM8 21h8" />
    </>
  ),
  settings: (
    <>
      <path d="M4 6h16M4 12h16M4 18h16" />
      <circle cx="9" cy="6" r="2" fill="var(--nav-icon-surface, #f9f9f9)" />
      <circle cx="15" cy="12" r="2" fill="var(--nav-icon-surface, #f9f9f9)" />
      <circle cx="9" cy="18" r="2" fill="var(--nav-icon-surface, #f9f9f9)" />
    </>
  ),
  labels: (
    <>
      <path d="M4 5h8l8 8-7 7-9-9z" />
      <circle cx="8" cy="9" r="1" />
      <path d="M7 3h8l6 6" />
    </>
  ),
  qesMail: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m4 7 8 6 8-6" />
      <circle cx="17.5" cy="16" r="2" />
    </>
  ),
  wbLabel: (
    <>
      <path d="M5 8h14l1 12H4zM9 9V6a3 3 0 0 1 6 0v3" />
      <path d="M12 13h5M12 16h4" />
    </>
  ),
  azLabel: (
    <>
      <path d="M3 4h9l9 9-8 8-10-10z" />
      <circle cx="7.5" cy="8" r="1" />
      <text x="9" y="16" fill="currentColor" stroke="none" fontSize="7" fontWeight="700" letterSpacing="-0.5">
        AZ
      </text>
    </>
  ),
  geLabel: (
    <>
      <rect x="4" y="3" width="16" height="18" rx="2" />
      <path d="M7 7h10M7 18h10" />
      <text x="7.5" y="15" fill="currentColor" stroke="none" fontSize="7" fontWeight="700" letterSpacing="-0.5">
        GE
      </text>
    </>
  ),
  parcelLabel: (
    <>
      <path d="m3 8 8-4 8 4v10l-8 4-8-4zM3 8l8 4 8-4M11 12v10" />
      <path d="M14 14h3v4h-3z" />
    </>
  ),
};

export default function NavIcon({ kind }: { kind: NavIconKind }) {
  return (
    <svg
      className="sort-center-nav-icon"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {drawings[kind]}
    </svg>
  );
}
